export default "__VITE_ASSET__6ba05d6c__"